module.exports = __webpack_public_path__ + "img/aboutUs71.05c070f0.png";